import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../Icon';
import styles from './EmptyFolders.module.scss';

const EmptyFolders = ({ type, archive }) => {
  const { t } = useTranslation();

  if (archive) {
    return (
      <div className={styles.container}>
        <Icon src="emptyPrivateFolders" className={styles.icon} />
        <div className={styles.title}>{t('empty_folders.archive.title')}</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {type === 'folders' && (
        <>
          <Icon src="emptyPrivateFolders" className={styles.icon} />
          <div className={styles.title}>{t('empty_folders.title')}</div>
          <div className={styles.text}>{t('empty_folders.text')}</div>
        </>
      )}
      {type === 'team' && (
        <>
          <Icon src="emptyTeamFolders" className={styles.icon} />
          <div className={styles.title}>{t('empty_team.title')}</div>
          <div className={styles.text}>{t('empty_team.text')}</div>
        </>
      )}
    </div>
  );
};

export default EmptyFolders;
